import React from 'react';

const IconCategoryStays = props => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      fill="none"
      viewBox="0 0 32 32"
    >
      <rect width="32" height="32" fill="#fff" fillOpacity="0.5" rx="8"></rect>
      <rect
        width="31.5"
        height="31.5"
        x="0.25"
        y="0.25"
        stroke="#fff"
        strokeOpacity="0.5"
        strokeWidth="0.5"
        rx="7.75"
      ></rect>
      <path
        fill="#19191A"
        stroke="#19191A"
        strokeWidth="0.2"
        d="M16.18 10.986c.811 0 1.608.205 2.312.595.704.391 1.291.954 1.703 1.632l.14.214c.345.488.799.894 1.33 1.188a4.1 4.1 0 0 0 1.993.513c.1 0 .198.04.27.109a.37.37 0 0 1 .112.264v4.208c0 .1-.04.195-.112.265a.39.39 0 0 1-.538 0 .37.37 0 0 1-.114-.265v-3.85a4.9 4.9 0 0 1-2.112-.665 4.74 4.74 0 0 1-1.469-1.36l-.157-.24a3.84 3.84 0 0 0-1.422-1.365 3.99 3.99 0 0 0-3.87 0 3.84 3.84 0 0 0-1.422 1.365 4.7 4.7 0 0 1-1.626 1.6c-.64.38-1.365.607-2.112.666v3.849a.37.37 0 0 1-.113.265.387.387 0 0 1-.538 0 .37.37 0 0 1-.113-.265v-4.207c0-.1.04-.196.113-.265a.4.4 0 0 1 .27-.109c.698 0 1.385-.177 1.992-.513a3.97 3.97 0 0 0 1.47-1.402c.412-.678 1-1.24 1.703-1.631.704-.39 1.5-.596 2.31-.596Z"
      ></path>
      <path
        fill="#19191A"
        stroke="#19191A"
        strokeWidth="0.2"
        d="M22.318 18.823c.622 0 1.22.24 1.66.667.442.427.69 1.008.692 1.614v4.508a.37.37 0 0 1-.113.265.39.39 0 0 1-.269.109h-1.52v-.001a.4.4 0 0 1-.244-.085.37.37 0 0 1-.131-.222 1.52 1.52 0 0 0-.543-.906 1.6 1.6 0 0 0-.88-.35l-.139-.006h-9.296a1.6 1.6 0 0 0-1.018.356 1.52 1.52 0 0 0-.542.906.37.37 0 0 1-.133.222.4.4 0 0 1-.244.086H8.079a.4.4 0 0 1-.27-.109.37.37 0 0 1-.112-.265v-4.508c.001-.606.25-1.187.69-1.614a2.4 2.4 0 0 1 1.662-.667zm-12.27.747c-.42 0-.825.162-1.122.45a1.52 1.52 0 0 0-.465 1.085v4.134h.843a2.3 2.3 0 0 1 .823-1.116c.407-.296.9-.456 1.408-.454h9.296a2.4 2.4 0 0 1 1.41.454c.386.28.672.67.822 1.116h.843v-4.134l-.008-.152a1.52 1.52 0 0 0-.458-.933c-.297-.288-.7-.45-1.122-.45z"
      ></path>
      <path
        fill="#19191A"
        stroke="#19191A"
        strokeWidth="0.2"
        d="m14.259 15.998.227.01a2.34 2.34 0 0 1 1.4.646c.433.42.677.99.678 1.584v.958c0 .1-.04.196-.112.266a.4.4 0 0 1-.27.107h-4.618a.4.4 0 0 1-.27-.107.37.37 0 0 1-.112-.266v-.958a2.21 2.21 0 0 1 .678-1.586 2.34 2.34 0 0 1 1.63-.654zm-.769.747c-.41 0-.803.158-1.092.439-.29.28-.452.66-.453 1.055v.583h3.856v-.584a1.47 1.47 0 0 0-.45-1.054 1.57 1.57 0 0 0-1.092-.439z"
      ></path>
      <path
        fill="#19191A"
        stroke="#19191A"
        strokeWidth="0.2"
        d="M24.288 22.366c.1 0 .197.039.269.109a.37.37 0 0 1 0 .53.4.4 0 0 1-.269.108H8.08a.4.4 0 0 1-.27-.108.37.37 0 0 1 0-.53.4.4 0 0 1 .27-.109zm-5.413-6.368c.61 0 1.198.235 1.63.654.434.42.678.99.68 1.586v.958c0 .1-.042.196-.114.266a.39.39 0 0 1-.268.107h-4.62a.4.4 0 0 1-.269-.107.37.37 0 0 1-.112-.266v-.958a2.21 2.21 0 0 1 .677-1.584 2.35 2.35 0 0 1 1.628-.656zm-.768.747c-.41 0-.802.158-1.091.439-.29.28-.45.66-.45 1.054v.584h3.855v-.583l-.008-.147a1.48 1.48 0 0 0-.445-.908 1.57 1.57 0 0 0-1.093-.439z"
      ></path>
      <path
        stroke="#19191A"
        strokeLinecap="round"
        d="M5.172 26.484V12.482a1 1 0 0 1 .511-.872l10.151-5.69a1 1 0 0 1 .978 0l10.152 5.69a1 1 0 0 1 .51.872v14.002"
      ></path>
    </svg>
  );
};

export default IconCategoryStays;
